// extracted by mini-css-extract-plugin
module.exports = {"edit-interview-screen":"EditInterviewScreen_edit-interview-screen__1Hdky","title":"EditInterviewScreen_title__hagYK","form-card":"EditInterviewScreen_form-card__2ur9o"};